import { render, staticRenderFns } from "./AccessCodePage.vue?vue&type=template&id=64be090c&scoped=true"
import script from "./AccessCodePage.vue?vue&type=script&lang=js"
export * from "./AccessCodePage.vue?vue&type=script&lang=js"
import style0 from "./AccessCodePage.vue?vue&type=style&index=0&id=64be090c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64be090c",
  null
  
)

export default component.exports